import React, { useCallback } from "react";
import { Icon } from "antd";
import { withApollo } from "react-apollo";

import { GET_ENTITY_PREVIEW_DATA } from "./queries";

const ExpanderIcon = ({ row, ...apolloProps }) => {
    const onEnter = useCallback(() => {
        apolloProps.client.writeQuery({
            query: GET_ENTITY_PREVIEW_DATA,
            data: {
                dispositionInfoBar: {
                    id: 0,
                    itemId: row.original.id,
                    show: true,
                    __typename: "dispositionInfoBar",
                },
            },
        });
    }, [row, apolloProps.client]);
    const onLeave = useCallback(() => {
        apolloProps.client.writeQuery({
            query: GET_ENTITY_PREVIEW_DATA,
            data: {
                dispositionInfoBar: {
                    id: 0,
                    show: false,
                    itemId: row.original.id,
                    __typename: "dispositionInfoBar",
                },
            },
        });
    }, [apolloProps.client, row.original.id]);

    return (
        <Icon
            data-testid="disposition-table-expander"
            theme="filled"
            type={row.isExpanded ? "folder" : "folder-open"}
            onMouseEnter={onEnter}
            onMouseLeave={onLeave}
        />
    );
};

const ExpanderIconApollo = withApollo(ExpanderIcon);

export const expanderIconRow = {
    id: "expander",
    width: 35,
    expander: true,
    Expander: row => <ExpanderIconApollo row={row} />,
};
